import React from "react";

const TimelineItem = ({ item, index }) => {
  const isRight = index % 2 === 1;
  return (
    <section
      className={`relative grid md:grid-cols-2 gap-8 items-center ${
        isRight ? "" : "md:[&>*:first-child]:order-2"
      }`}
    >
      <div className="absolute left-1/2 top-0 bottom-0 hidden md:block w-px bg-[#E85D44]/20 -translate-x-1/2" />
      <div className="relative">
        <div className="inline-flex items-center gap-2 mb-3">
          <span className="text-sm font-bold px-3 py-1 rounded-full bg-[#FFD93D] text-gray-900 uppercase tracking-[0.3em]">
            {item.year}
          </span>
          {item.badge && (
            <span className="text-xs font-bold px-2.5 py-1 rounded-full bg-[#E85D44] text-white uppercase tracking-[0.25em]">
              {item.badge}
            </span>
          )}
        </div>
        <h3 className="text-2xl md:text-3xl font-extrabold text-gray-900">{item.title}</h3>
        <p className="mt-3 text-[15px] leading-7 text-gray-600">
          {item.body}
        </p>
      </div>
      <div className="grid grid-cols-2 gap-4">
        {item.images.slice(0, 2).map((src, i) => (
          <img
            key={i}
            src={src}
            alt=""
            className="rounded-2xl bg-gray-100 aspect-[4/3] object-cover shadow-lg border border-gray-200"
          />
        ))}
      </div>
    </section>
  );
};

export default TimelineItem;
